/** The centered card shared by the sign-in, reset and set-password screens. */
export default function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}) {
  return (
    // min-h-dvh: the screen the browser leaves visible. The padding keeps the card clear of the notch and home indicator.
    <div
      className="min-h-screen min-h-dvh flex items-center justify-center bg-background
                 pl-[max(1rem,env(safe-area-inset-left))] pr-[max(1rem,env(safe-area-inset-right))]
                 pt-[max(2rem,env(safe-area-inset-top))] pb-[max(2rem,env(safe-area-inset-bottom))]"
    >
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <img src="/favicon.svg" alt="Cerebro Diem" className="w-16 h-16 rounded-2xl mx-auto mb-4" />
          <h1 className="text-2xl font-bold">{title}</h1>
          {subtitle && <p className="text-on-surface-variant">{subtitle}</p>}
        </div>
        {children}
      </div>
    </div>
  );
}
